import { render } from "./DeleteReportsTable.vue?vue&type=template&id=a9a67a3e"
import script from "./DeleteReportsTable.vue?vue&type=script&lang=js"
export * from "./DeleteReportsTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__